import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.parse-int.js";
import { compose, branch, renderNothing, withHandlers, withProps, withPropsOnChange, withStateHandlers } from 'recompose';
import SurveyWrapper from "./SurveyWrapper";
import componentErrorBoundary from "../enhancers/componentErrorBoundary";
import initialPropsContextEnhancer from "../InitialPropsContext/enhancer";
var adminSurvey = '5b35ca55-6531-49f8-b9e4-8f21a7b590dd';
var agentSurvey = '9b1eea12-bc3e-48ea-99b2-45a69740dbc5';
var adminSurveyDelay = 30;
var agentDeclinedSurveyDelay = 30;
var agentCompletedSurveyDelay = 120;
var firstSurveyDelay = 5;
var getCurrentSurveyStatus = function getCurrentSurveyStatus() {
  return JSON.parse(localStorage.getItem('_applyboard_survey_status'));
};
var getFirstSeenStatus = function getFirstSeenStatus() {
  return JSON.parse(localStorage.getItem('_applyboard_first_seen_status'));
};
var enhancer = compose(componentErrorBoundary, initialPropsContextEnhancer(), withProps(function (_ref) {
  var initial_props = _ref.initial_props;
  return {
    currentUserRole: initial_props && initial_props.role || 'visitor'
  };
}), branch(function (_ref2) {
  var currentUserRole = _ref2.currentUserRole;
  return !currentUserRole || currentUserRole === 'visitor';
}, renderNothing), branch(function () {
  if (localStorage && typeof localStorage !== 'undefined' && localStorage !== null) {
    try {
      localStorage.setItem('test', 'true');
      if (localStorage.getItem('test') === 'true') {
        localStorage.removeItem('test');
        return false;
      }
      return true;
    } catch (e) {
      return true;
    }
  } else {
    return true;
  }
}, renderNothing), withStateHandlers({
  showSurvey: false,
  surveyJSON: {
    surveyId: null
  }
}, {
  setShowSurvey: function setShowSurvey(state, _ref3) {
    var currentUserRole = _ref3.currentUserRole;
    return function (firstTimeSeeing, elapsedTime) {
      var completedLastTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      switch (currentUserRole) {
        case 'student_advisor':
        case 'content_editor':
        case 'sales_person':
        case 'admin':
        case 'sys_admin':
          if (firstTimeSeeing && elapsedTime > firstSurveyDelay || !firstTimeSeeing && elapsedTime > adminSurveyDelay) {
            return {
              showSurvey: true,
              surveyJSON: {
                surveyId: adminSurvey
              }
            };
          }
          break;
        case 'agent':
          if (firstTimeSeeing && elapsedTime > firstSurveyDelay) {
            return {
              showSurvey: true,
              surveyJSON: {
                surveyId: agentSurvey
              }
            };
          }
          if (completedLastTime && elapsedTime > agentCompletedSurveyDelay || !completedLastTime && elapsedTime > agentDeclinedSurveyDelay) {
            return {
              showSurvey: true,
              surveyJSON: {
                surveyId: agentSurvey
              }
            };
          }
          break;
        default:
          return {
            showSurvey: false
          };
      }
    };
  },
  hideSurvey: function hideSurvey() {
    return function () {
      return {
        showSurvey: false
      };
    };
  }
}), withPropsOnChange(['currentUserRole'], function (_ref4) {
  var setShowSurvey = _ref4.setShowSurvey;
  var currentSurveyStatus = getCurrentSurveyStatus();
  var firstSeenStatus = getFirstSeenStatus();
  if (!firstSeenStatus && !currentSurveyStatus) {
    // if no firstSeenStatus or currentSurveyStatus, never seen them before, so just save first seen to localStorage
    localStorage.setItem('_applyboard_first_seen_status', JSON.stringify({
      dateFirstSeen: Date.now()
    }));
  } else if (firstSeenStatus && !currentSurveyStatus) {
    // if firstSeenStatus AND no currentSurveyStatus AND days since first seen < firstSurveyDelay, figure out time passed and send to showSurvey function, which will decide what to do
    var daysSinceFirstSeen = (Date.now() - firstSeenStatus.dateFirstSeen) / (1000 * 60 * 60 * 24);
    setShowSurvey(true, daysSinceFirstSeen);
  } else if (currentSurveyStatus) {
    // if firstSeenStatus AND currentSurveyStatus, we are in regular recurring survey mode, just check daysSinceShown
    var daysSinceShown = (Date.now() - currentSurveyStatus.dateLastShown) / (1000 * 60 * 60 * 24);
    var completedLastTime = currentSurveyStatus.completed;
    setShowSurvey(false, daysSinceShown, completedLastTime);
  }
}), branch(function (_ref5) {
  var showSurvey = _ref5.showSurvey,
    surveyJSON = _ref5.surveyJSON;
  return !showSurvey || !surveyJSON || !surveyJSON.surveyId;
}, renderNothing), withHandlers({
  saveToStorageAndCloseModal: function saveToStorageAndCloseModal(_ref6) {
    var currentUserRole = _ref6.currentUserRole,
      hideSurvey = _ref6.hideSurvey;
    return function (completed) {
      var storedSurveyStatus = {
        role: currentUserRole,
        dateLastShown: Date.now(),
        completed: completed
      };
      localStorage.setItem('_applyboard_survey_status', JSON.stringify(storedSurveyStatus));
      hideSurvey();
    };
  }
}), withHandlers({
  onDeclineSurvey: function onDeclineSurvey(_ref7) {
    var currentUserRole = _ref7.currentUserRole,
      saveToStorageAndCloseModal = _ref7.saveToStorageAndCloseModal;
    return function () {
      saveToStorageAndCloseModal(false);
      switch (currentUserRole) {
        case 'student_advisor':
        case 'content_editor':
        case 'sales_person':
        case 'admin':
        case 'sys_admin':
          break;
        case 'agent':
          break;
        default:
      }
    };
  },
  onCompleteSurvey: function onCompleteSurvey(_ref8) {
    var currentUserRole = _ref8.currentUserRole,
      saveToStorageAndCloseModal = _ref8.saveToStorageAndCloseModal;
    return function (survey) {
      saveToStorageAndCloseModal(true);
      switch (currentUserRole) {
        case 'student_advisor':
        case 'content_editor':
        case 'sales_person':
        case 'admin':
        case 'sys_admin':
          if (survey.valuesHash['Overall Satisfaction Score']) {
            survey.valuesHash['Overall Satisfaction Score'] = parseInt(survey.valuesHash['Overall Satisfaction Score'], 10);
          }
          break;
        case 'agent':
          if (survey.valuesHash['Agent NPS Score']) {
            survey.valuesHash['Agent NPS Score'] = parseInt(survey.valuesHash['Agent NPS Score'], 10);
          }
          break;
        default:
      }
    };
  }
}));
export default enhancer(SurveyWrapper);